/**************************************************
 * Nombre:       Calendario_Anuncio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, AvatarGroup, Button, Grid, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {GRADIENTE} from "../../../Constantes";
import uno from "../../../Recursos/uno.jpeg";
import dos from "../../../Recursos/dos.jpeg";
import tres from "../../../Recursos/tres.jpeg";
import {obtenerProximoEvento} from "../../../CodigoNegocio/Eventos/obtenerProximoEvento";
import {irUrl} from "../../../Utilidades/irUrl";

const Calendario_Anuncio = ({eventoViene}) => {
    const {sCell} = useResponsive()
    const [evento, setEvento] = useState({});

    useEffect(() => {


        obtenerProximoEvento().then((dox) => {

            setEvento(dox)
            if (eventoViene.nombre) {
                setEvento(eventoViene);
            }

        })


    }, [eventoViene]);
    return (
        <Grid
            container
            direction="row-reverse"
            justifyContent={'center'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'center'}}>
                <img src={evento.img} width={'70%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 6}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 6 : 0}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{color: '#262626'}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography
                            sx={{
                                fontSize: sCell ? 32 : 40,
                                fontWeight: 700,
                                lineHeight: 1.1,
                                textAlign: sCell ? "center" : 'left'
                            }}
                        >{evento.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <Typography
                            sx={{
                                fontSize: 16,
                                fontWeight: 400,
                                textAlign: sCell ? "center" : 'left',
                                color: '#545454',
                                textOverflow: "ellipsis",
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: sCell ? 14 : 8,
                            }}
                        >
                            {evento.descripcion}
                        </Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Grid
                            container
                            justifyContent={sCell ? 'center' : 'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            <Grid container size={{xs: 4, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                <AvatarGroup spacing={25}>
                                    <Avatar sx={{width: 50, height: 50}} alt="Remy Sharp" src={uno}/>
                                    <Avatar sx={{width: 50, height: 50}} alt="Travis Howard" src={dos}/>
                                    <Avatar sx={{width: 50, height: 50}} alt="Cindy Baker" src={tres}/>
                                </AvatarGroup>
                            </Grid>

                            <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{
                                    fontSize: 24,
                                    fontWeight: 600
                                }}>{`+${evento.confirmados ? evento.confirmados : 100}`}</Typography>
                            </Grid>

                            <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                                <Typography
                                    sx={{
                                        fontSize: sCell ? 14 : 16,
                                        fontWeight: 400,
                                        color: '#545454',
                                        lineHeight: 1.1
                                    }}>Confirmado la asistencia</Typography>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 3}}>

                        <Button
                            onClick={() => irUrl(evento.link)}
                            disabled={evento.fecha < new Date().getTime()}
                            sx={{
                                background: evento.fecha < new Date().getTime() ? ' ' : GRADIENTE,
                                px: 6
                            }}> Registrarse</Button>

                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Calendario_Anuncio